import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { merge } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "../../services/api.service";

@Component({
    selector: "ngx-single-article",
    templateUrl: "./single-article.component.html",
    styleUrls: ["./single-article.component.scss"],
})
export class SingleArticleComponent implements OnInit {
    constructor(
        private _router: Router,
        private _aS: ApiService,
        private _activatedRoute: ActivatedRoute
    ) {}
    public articleData: any;
    private _contractAddress: string;
    public articleNotFound: boolean = false;

    ngOnInit(): void {
        const merged = merge(
            this._activatedRoute.parent.params,
            this._activatedRoute.params
        );
        merged.subscribe((params) => {
            console.log("Merged params:", params);
            if (params.contractAddress) {
                this._contractAddress = params.contractAddress;
            }
            if (params.id && this._contractAddress) {
                this._aS
                    .getSingleArticle(this._contractAddress, params.id)
                    .subscribe(
                        (article) => {
                            this.articleData = article;
                            console.log(article);
                        },
                        (err) => {
                            this.articleNotFound = true;
                        }
                    );
            }
        });
    }

    onBackToCrowdsale() {
        this._router.navigate([this._contractAddress]);
    }
}
